export default __webpack_public_path__ + "audio/be76f69cf68e467d6daa3be23963bb25.mp3";